<!--
 * @Autor: yingna.gao
 * @Date: 2022-07-07 11:23:38
 * @LastEditTime: 2022-07-18 16:40:45
 * @LastEditors: yingna.gao
 * @Description:
 * @FilePath: /common-web/src/views/standard/cockpit/components/workbench.vue
-->
<template>
  <div>
    <div class="workbench-warp">
      <div class="clearfix workbench-header">
        <span class="float-left workbench-title">工作台</span>
        <el-button class="float-right config-btn" icon="el-icon-setting" @click="conFigWorkbench">
          配置
        </el-button>
      </div>
      <workbench-item :item-list="workbenchList" :is-jump="true"/>
    </div>
    <workbench-config
      v-if="dialogFormVisible"
      :visible.sync="dialogFormVisible"
      @refresh="handleUpdateList"
    />
  </div>
</template>

<script>
import WorkbenchItem from "./workbench-item";
import WorkbenchConfig from "./workbench-config";
import cockpitApi from "@/api/cockpit/cockpit";
export default {
  name: "Workbench",
  components: {
    WorkbenchItem,
    WorkbenchConfig
  },
  data() {
    return {
      dialogFormVisible: false,
      workbenchList: []
    };
  },
  created() {
    this.getWorkbenchList();
  },
  methods: {
    conFigWorkbench() {
      this.dialogFormVisible = true;
    },
    handleUpdateList() {
      this.getWorkbenchList();
    },
    getWorkbenchList() {
      cockpitApi.getHomeConfig({}).then(res => {
        if (res.success && res.data) {
          const extendedData = res.data.extendedData || {};
          this.$store.commit("user/SET_LAYOUT_CONFIG_EXTENED_DATA", extendedData);
          this.workbenchList = extendedData.workbenchList || [];
        }
      });
    }
  }
};
</script>

<style scoped lang='scss'>
.workbench-warp{
    padding:16px;
}
.workbench-header{
    margin-bottom: 16px;
}
.workbench-title{
 color: #21252E;
 font-weight: 500;
 font-size: 16px;
 line-height: 32px;
}
.config-btn.el-button{
    padding: 8px 12px;
}
</style>
